<!-- section template -->
<template>
  <header :class="[$style.header, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <div class="header__inner">
      <div class="container--menu">
        <div class="header__headerList">
          <div class="header__headerLeft">
            <router-link :to="{ name: 'home' }">
              <img
                alt="logo"
                class="header__logo"
                :src="currentMerchant.logo || require($globalIsDingBeauty ? `@assets/images/dingbeauty/default/logo-default.svg` : `@assets/images/default/logo-default.svg`)"
              />
            </router-link>
          </div>
          <div class="header__headerCenter">
            <ul :class="[$style.menuList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
              <template v-for="(menuItem, index) in menuList">
                <li :key="index" class="menuList__item" :class="menuItem.type || 'link'">
                  <template v-if="menuItem.type === 'link' || !menuItem.type">
                    <router-link class="menuList__link" :to="menuItem.to" active-class="isActive" @click.native="$globalHambugerOpen = false">
                      <i v-if="menuItem.icon" :class="`menuList__icon ${menuItem.icon} mr-2`"></i>
                      <span>{{ menuItem.title }}</span>
                    </router-link>
                  </template>
                  <template v-if="menuItem.type === 'lightbox' && showStoreButton(menuItem.data)">
                    <div class="menuList__link" :class="{ isActive: menuItem.data === storeItem.storeType }" @click="openDialogStoreJtails(menuItem.data)" v-html="menuTypeLightboxText(menuItem)">
                    </div>
                  </template>
                </li>
              </template>
            </ul>
          </div>

          <!-- PC -->
          <div class="header__headerRight">
            <ul :class="[$style.menuRightList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
              <template v-for="(menuRightItem, index) in menuRightList">
                <li :key="`menuRightList-${index}`" class="menuRightList__item" :class="menuRightItem.type || 'link'">
                  <template v-if="menuRightItem.type === 'link' || !menuRightItem.type">
                    <router-link class="menuRightList__link" :to="menuRightItem.to" active-class="isActive" @click.native="$globalHambugerOpen = false">
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span>{{ menuRightItem.title }}</span>
                    </router-link>
                  </template>
                  <template v-if="menuRightItem.type === 'a'">
                    <a class="menuRightList__link" :href="menuRightItem.href" :target="menuRightItem.target">
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span class="ml-1 menuRightList__text">{{ menuRightItem.title }}</span>
                    </a>
                  </template>
                  <!-- 登入/註冊 -->
                  <template v-if="menuRightItem.type === 'login'">
                    <div class="menuRightList__link" @click="goToLogin">
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span class="ml-1 menuRightList__text">{{ menuRightItem.title }}</span>
                    </div>
                  </template>

                  <template v-if="menuRightItem.type === 'member'">
                    <el-popover v-if="!$globalIsMobileDevice" placement="bottom-end" width="321" trigger="hover" class="d-none d-md-block" popper-class="isStyleMember">
                      <div class="memberBoxtop d-flex justify-content-between mb-2">
                        <div class="align-self-center">
                          <div class="d-flex">
                            <img :src="require(`@assets/images/${$globalProjectName}/memberLevel/member_header_icon.svg`)" alt="" class="mr-3" :width="$globalIsDingBeauty ? '35' : '45'" />
                            <div class="memberBoxtop__meta">
                              <router-link class="memberBoxtop__name" :to="menuRightItem.to">
                                {{ currentMember ? currentMember.fullName || '會員' : '會員 ' }}
                              </router-link>
                              <div class="level">{{ currentMember.level.title }}</div>
                            </div>
                          </div>
                        </div>
                        <router-link
                          v-if="hasMerchantDeposit"
                          :to="{
                            name: 'member-deposit',
                          }"
                          class="isDeposit ml-3 align-self-center"
                        >
                          <i class="fal fa-usd-circle mx-1"></i>
                          <span class="font-number">
                            {{ depositPoint }}
                          </span>
                        </router-link>
                      </div>
                      <ul :class="$style.memberMenuList">
                        <li v-for="(memberMenuItem, index2) in memberMenuList" :key="index2" class="memberMenuList__item">
                          <router-link class="memberMenuList__link" :to="memberMenuItem.to" active-class="isActive" @click.native.capture="goToLink($event, memberMenuItem.to)">
                            {{ memberMenuItem.title }}
                          </router-link>
                        </li>
                        <li class="memberMenuList__item">
                          <div class="memberMenuList__link" @click="goToLogout"> 登出 </div>
                        </li>
                      </ul>
                      <router-link slot="reference" class="menuRightList__link" :to="menuRightItem.to" active-class="isActive" @click.native="$globalHambugerOpen = false">
                        <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                        <span class="ml-1 menuRightList__text">{{ currentMember.fullName ? currentMember.fullName || '會員' : '會員' }}</span>
                      </router-link>
                    </el-popover>
                    <router-link v-else class="menuRightList__link" :to="menuRightItem.to" active-class="isActive" @click.native="$globalHambugerOpen = false">
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span class="ml-1 menuRightList__text">{{ currentMember.fullName ? currentMember.fullName || '會員' : '會員' }}</span>
                    </router-link>
                  </template>
                  <!-- 預約中的服務 -->
                  <template v-if="menuRightItem.type === 'cart'">
                    <el-popover v-if="!$globalIsMobileDevice" placement="bottom-end" width="432" trigger="hover" class="d-none d-md-block" popper-class="isStyleCartReservation">
                      <div v-if="!isLoggedIn" class="content d-flex flex-column justify-content-center align-items-center">
                        <div class="text-primary-dark fs-xl mb-3">尚未登入</div>
                        <BaseButton class="isStylePrimary isFull" :class="{ isRadius: $globalIsJtails }" @click="goToLogin"> 登入 </BaseButton>
                      </div>
                      <div v-else-if="isOrderEmpty" class="content d-flex flex-column justify-content-center align-items-center">
                        <div class="text-primary-dark fs-xl mb-3">尚無預約</div>
                        <span>{{ $t('site.NO_CART_ITEM_TEXT') }}</span>
                      </div>
                      <div v-else>
                        <div class="cartReservationList">
                          <FormCartReservation v-model="submitData.orders" :cart="unPaidContainerList[0]" style-type="header" />
                        </div>
                        <template v-if="isShowCountDown">
                          <BaseCountDown :time="Date.parse(expiredDate(unPaidContainerList[0].updatedDate)).toString()" class-name="isStyleCart" class="mt-3" @finish="countDownFinish" />
                        </template>
                        <hr />
                        <BaseButton
                          class="isStylePrimary isFull"
                          :class="{ isRadius: $globalIsJtails }"
                          :to="{
                            name: 'reservation-checkout',
                          }"
                        >
                          立即付款
                        </BaseButton>
                      </div>
                      <router-link slot="reference" class="menuRightList__link order-btn" :to="menuRightItem.to" active-class="isActive">
                        <div v-if="isLoggedIn" class="warn-wrapper" :class="{ active: isShowReservedCount, round: $globalIsJtails }">
                          <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`" style="margin-top: -2px"></i>
                          <span v-if="isShowReservedCount" class="menuRightList__reserveCount">{{ submitData.orders.length }}</span>
                          <el-statistic
                            v-if="isShowCountDown && !isOrderEmpty"
                            ref="statistic"
                            format="mm:ss"
                            :value="Date.parse(expiredDate(unPaidContainerList[0].updatedDate)).toString()"
                            time-indices
                          >
                          </el-statistic>
                        </div>
                        <div v-else class="warn-wrapper">
                          <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`" style="margin-top: -2px"></i>
                        </div>

                        <div class="normal-wrapper" :class="{ active: isShowReservedCount }">
                          <span class="ml-1 menuRightList__text">
                            {{ menuRightItem.title }}
                          </span>
                        </div>
                      </router-link>
                    </el-popover>
                    <router-link v-else class="menuRightList__link" :to="menuRightItem.to" active-class="isActive" @click.native="$globalHambugerOpen = false">
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span class="ml-1 menuRightList__text">{{ menuRightItem.title }}</span>
                    </router-link>
                  </template>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div class="header__headerList--mobile">
          <div class="header__headerLeft">
            <div class="header__icon hambuger" @click="$globalHambugerOpen = !$globalHambugerOpen">
              <div v-if="$globalHambugerOpen" class="hambuger__close"></div>
              <i v-else class="fal fa-bars"></i>
            </div>
            <span v-if="$globalIsJtails" class="header__icon flex ml-2" style="margin-top: -2px" @click="showSearch">
              <i class="fontello fontello-search fa-xl"></i>
              <div :class="$style.headerSearch">
                <transition name="fade">
                  <div v-show="isSearchOpen" class="headerSearch__box">
                    <div class="container">
                      <div class="headerSearch__inputBox">
                        <input ref="searchMobileInput" v-model="query" class="headerSearch__input" type="text" placeholder="找商品" inputmode="search" @keyup.enter="searchProduct" />
                        <div class="headerSearch__close" @click.stop="closeSearch"></div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </span>
          </div>
          <div class="header__headerCenter">
            <router-link :to="{ name: 'home' }">
              <img alt="logo" class="header__logo" :src="currentMerchant.logo || require(`@assets/images/${$globalProjectName}/default/logo-default.svg`)" />
            </router-link>
          </div>

          <!-- Mobile -->
          <div class="header__headerRight">
            <div class="header__icon" @click="isLoggedIn ? goToMember() : goToLogin()">
              <i class="" :class="`${isLoggedIn ? 'fas' : 'fal'} fa-user-circle`"></i>
            </div>
            <a v-if="$globalIsJtails" class="header__icon" :href="shopUrl" target="_blank">
              <i class="fal fa-shopping-bag"></i>
            </a>
            <router-link
              class="header__icon"
              :to="{
                name: 'reservation-checkout',
              }"
            >
              <div class="time-wrapper">
                <i class="fontello fontello-time"></i>
                <span v-if="submitData.orders && submitData.orders.length" class="orderNumber" :class="{ jtails: $globalIsJtails }">{{ submitData.orders.length }}</span>
              </div>
            </router-link>
          </div>

          <div :class="[$style.mobileMenu, { [$style.isMenuOpen]: $globalHambugerOpen, [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
            <div class="mobileMenu__top">
              <div :class="[$style.mobileMenuList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
                <template v-for="(menuItem, index) in menuList">
                  <div :key="index" class="mobileMenuList__item" :class="menuItem.type || 'link'">
                    <template v-if="menuItem.type === 'link' || !menuItem.type">
                      <router-link class="mobileMenuList__link" :to="menuItem.to" active-class="isActive" @click.native="$globalHambugerOpen = false">
                        <i v-if="menuItem.icon" :class="`mobileMenuList__icon ${menuItem.icon}`"></i>
                        <span>{{ menuItem.title }}</span>
                      </router-link>
                    </template>
                    <template v-if="menuItem.type === 'lightbox'">
                      <div
                        class="mobileMenuList__link"
                        :class="{ isActive: menuItem.data === storeItem.storeType }"
                        @click="openDialogStoreJtails(menuItem.data)"
                        v-html="menuTypeLightboxText(menuItem)"
                      >
                      </div>
                    </template>
                  </div>
                </template>
                <hr class="mobileMenuList__hr" />
                <div class="mobileMenuList__item">
                  <div class="mobileMenuList__link" @click="isLoggedIn ? goToMember() : goToLogin()">
                    <span v-if="isLoggedIn">會員中心</span>
                    <span v-else>登入｜註冊</span>
                  </div>
                </div>
                <div v-if="$globalIsJtails" class="mobileMenuList__item">
                  <a class="mobileMenuList__link" :href="shopUrl" target="_blank">
                    <span>線上購物<i class="fal fa-external-link ml-2 fs-sm"></i></span>
                  </a>
                </div>
                <div class="mobileMenuList__item">
                  <router-link
                    class="mobileMenuList__link"
                    :to="{
                      name: 'reservation-checkout',
                    }"
                  >
                    待結帳預約
                  </router-link>
                </div>
              </div>
            </div>
            <div class="mobileMenu__bottom">
              <div :class="$style.mobileMenuListB">
                <div class="mobileMenuListB__title"> 服務條款 </div>
                <div class="mobileMenuListB__item">
                  <router-link class="mobileMenuListB__link" :to="{ name: 'privacy' }" active-class="isActive"> 使用細則＆隱私權條款 </router-link>
                </div>
              </div>
              <ul :class="$style.socialList">
                <li class="socialList__item">
                  <a v-if="$globalIsJtails" class="socialList__link" href="https://www.instagram.com/jtailspet/" target="_blank">
                    <i class="fontello fontello-instagram"></i>
                  </a>
                </li>
                <li v-if="!!currentMerchant.fbFanpageUrl" class="socialList__item">
                  <a class="socialList__link" :href="currentMerchant.fbFanpageUrl" target="_blank">
                    <i class="fontello fontello-facebook-light"></i>
                  </a>
                </li>
                <li v-if="!!currentMerchant.lineId || !!currentMerchant.lineFriendUrl" class="socialList__item">
                  <div style="padding-left: 4px" class="socialList__link" @click="openDialogLine">
                    <i class="fontello fontello-line"></i>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<!-- eslint-disable camelcase -->
<script>
import TheMixin from '../mixin/TheHeader'
import { jtailsMainMenuList, dingBeautyMainMenuList, jtailsMainMenuRightList, dingbeautyMainMenuRightList, memberMenuListJtails } from '@src/config/menu'
import { storeOptions } from '@utils/ipetbooking-options'
import { authComputed, merchantComputed } from '@store/helpers'
import { getStoreOption } from '@utils/ipetbooking-options'
import formatCurrency from '@utils/format-currency'
import _cloneDeep from 'lodash/cloneDeep'
import { getLocalStorage } from '@utils/localStorage'
import isBefore from 'date-fns/isBefore'
import parseISO from 'date-fns/parseISO'
import addMinutes from 'date-fns/addMinutes'
export default {
  name: 'TheHeader4',
  components: {
    FormCartReservation: () => import('@components/Form/FormCartReservation'),
  },
  mixins: [TheMixin],
  data() {
    return {
      isSearchOpen: false,
      query: '',
      shopUrl: window.globalData.APP_SHOP_URL,
      unPaidContainerList: getLocalStorage('currentUnpaidContiner') || [],
      submitData: {
        orders: getLocalStorage('currentUnpaidContiner') ? getLocalStorage('currentUnpaidContiner')[0]?.orders?.items : [],
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    menuList() {
      const map = {
        jtails: jtailsMainMenuList(),
        dingbeauty: dingBeautyMainMenuList(),
      }
      return map[this.$globalProjectName]
    },
    memberMenuList() {
      return memberMenuListJtails()
    },
    menuRightList() {
      const map = {
        jtails: jtailsMainMenuRightList(),
        dingbeauty: dingbeautyMainMenuRightList(),
      }
      return map[this.$globalProjectName]
    },
    storeItem() {
      return getStoreOption({
        value: this.$route.params.storeAlias,
        type: 'item',
      })
    },
    hasMerchantDeposit() {
      return !!this.currentMerchant.depositSetting
    },
    depositPoint() {
      return formatCurrency(this.currentMember?.point || 0)
    },
    isOrderEmpty() {
      return !this.unPaidContainerList.length || !this.submitData.orders.length
    },
    isShowCountDown() {
      return this.isBeforeNewDate(this.unPaidContainerList[0]?.updatedDate) && this.unPaidContainerList[0]?.is_temp === 1 && !this.unPaidContainerList[0]?.parent_id
    },
    isShowReservedCount() {
      return !!this.submitData.orders && !!this.submitData.orders.length
    },
  },
  watch: {
    isLoggedIn(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.tryToFetchContainerList()
      }
    },
    '$store.state.merchant.currentUnpaidContiner'() {
      this.submitData.orders = getLocalStorage('currentUnpaidContiner')[0]?.orders?.items || []
    },
  },
  mounted() {
    if (this.isLoggedIn) {
      this.tryToFetchContainerList()
    }
  },
  methods: {
    menuTypeLightboxText(menuItem) {
      const storeRouteList = ['store', 'reservation-item']

      const icon = menuItem.icon ? `<i class="menuList__icon ${menuItem.icon} mr-2"></i>` : ''

      const title = menuItem.title ? `<span>${menuItem.title}</span>` : ''

      const formatTitle = () => {
        if (storeRouteList.includes(this.$route.name)) {
          const type = menuItem.data
          const storeItem = getStoreOption({
            value: this.$route.params.storeAlias,
            type: 'item',
          })

          return storeItem.storeType === type ? storeItem.title : title
        } else {
          return title
        }
      }

      return `${icon}${formatTitle()}`
    },
    openDialogStoreJtails(storeType) {
      this.$globalDialog('DialogStore', {
        activeTab: storeType,
        isQuerySet: true,
      })
    },
    showSearch(e) {
      if (['I', 'SPAN'].includes(e.target.tagName)) {
        if (this.isSearchOpen === true) {
          if (this.query !== '') this.searchProduct()
          else this.closeSearch()
        } else {
          this.isSearchOpen = true
          this.$nextTick(() => {
            if (this.$globalHambugerOpen)
              setTimeout(() => {
                this.$refs['searchMobileInput'].focus()
              }, 1000)

            this.$refs['searchInput'][0].focus()
          })
        }
      }
    },
    closeSearch() {
      this.isSearchOpen = false
    },
    searchProduct() {
      if (this.query !== '') window.location = `${window.globalData.APP_SHOP_URL}?s=${this.query}&post_type=product`
    },
    goToLogout() {
      this.$router.push({
        name: 'logout',
      })
    },
    tryToFetchContainerList() {
      this.$store.dispatch('merchant/fetchContainerList', {
        types: ['booking'],
        is_temp: 1,
        paginate: 0,
      })
    },
    countDownFinish() {
      this.$alert(`預約已逾期`, {
        title: `提示`,
        showClose: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.tryToFetchContainerList()
        this.clearTempCart()
        this.unPaidContainerList = []
      })
    },
    isBeforeNewDate(date) {
      return isBefore(new Date(), this.expiredDate(date))
    },
    expiredDate(date) {
      return addMinutes(parseISO(date), this.currentMerchant.cosmeticSetting.tempTimePeriod)
    },
    clearTempCart() {
      this.$store.dispatch('cart/setTempCart', null)
    },
    showStoreButton(storeType) {
      const optionList = Object.freeze(
        storeOptions({
          type: 'open',
          storeType
        })
      )

      return optionList.length !== 0
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.header {
  // position: relative;
  position: fixed;
  top: 0;
  z-index: $z-index-header;
  width: 100vw;
  height: 80px;
  font-family: $font-serif;

  @include max-lg {
    height: 67px;
  }

  @media (max-width: 860px) {
    height: 60px;
  }

  :global {
    .time-wrapper {
      position: relative;
      .orderNumber {
        transform: scale(0.9);
        display: grid;
        place-items: center;
        position: absolute;
        right: -5px;
        top: 0;
        padding: 0 3px 0 5px;
        font-size: 12px;
        background-color: #e3c192;
        border-radius: 50%;
        color: #fff;

        &.jtails {
          background-color: #90b9ab;
        }
      }
    }

    .header {
      &__logo {
        height: 53px;
        max-width: 180px;
        width: 100%;

        @include max-md {
          height: 60px;
        }

        @media (max-width: 860px) {
          height: 40px;
          max-width: 130px;
        }
      }

      &__icon {
        font-size: 22px;
        color: #3f3a2e;
        cursor: pointer;

        &:hover,
        &:focus {
          color: $color-primary;
        }
      }

      &__inner {
        // position: fixed;
        // top: 0;
        // width: 100%;
        height: 80px;
        background: #fff;
        box-shadow: 0 3px 20px #1c2c5414;
        opacity: 1;

        @include max-lg {
          height: 67px;
        }

        @include max-md {
          height: 60px;
          background: #fff;
          border-bottom: $color-gray-4 1px solid;
          // box-shadow: 0 1px 2px #1C2C5414;
        }

        @media (max-width: 860px) {
          height: 60px;
          border-bottom: none;
          box-shadow: 0 3px 5px rgb(28 44 84 / 10%);
        }
      }

      &__headerList {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &--mobile {
          display: none;
          align-items: center;
          justify-content: space-between;
          height: 57px;
          padding: 0;

          @media (max-width: 860px) {
            display: flex;
          }

          .hambuger {
            width: 22.5px;
            font-size: 22px;

            &__close {
              position: relative;
              align-self: center;
              width: 22.5px;
              height: 22px;

              &::before {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 1px;
                content: '';
                background-color: #3f3a2e;
                transform: rotate(45deg);
              }

              &::after {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 1px;
                content: '';
                background-color: #3f3a2e;
                transform: rotate(-45deg);
              }

              &:hover {
                &::before,
                &::after {
                  background-color: $color-primary;
                }
              }
            }
          }
        }

        @media (max-width: 860px) {
          display: none;
        }
      }

      &__headerLeft {
        display: flex;
        flex-shrink: 0;
        align-items: center;

        @media (max-width: 860px) {
          width: auto;
          text-align: center;
        }
      }

      &__headerCenter {
        // width: #{ $container + ($container-gap * 2) + 10 };
        flex: 1;

        @media (max-width: 860px) {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &__headerRight {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .header {
          &__icon {
            &:not(:last-child) {
              margin-right: 1rem;
            }
          }
        }
      }

      &__headerLeft {
        width: calc((100% - #{$container} + (#{$container-gap} * 2)) / 2);
        min-width: 140px;
        @media screen and (max-width: calc(#{$container} + 450px)) {
          margin-right: 3rem;
        }
        // width: 300px;
        // @media screen and (max-width: 1200px) {
        //   width: 200px;
        // }

        @include max-md {
          width: auto;
          min-width: 50px;
          margin-right: 0;
        }
      }
    }

    .order-btn {
      display: flex !important;
      align-items: center;
      padding: 0 !important;

      .warn-wrapper {
        display: flex;
        padding: 0.58rem 0.875rem;
        padding-right: 0;
        align-items: center;

        &.active {
          background-color: rgba(228, 176, 180, 0.18);
          color: #ec5151;
          padding-right: 0.875rem;

          .el-statistic {
            width: auto;

            .number {
              font-size: 15px;
              color: #ec5151;
            }
          }
        }
      }
      .normal-wrapper {
        padding: 0.58rem 0.875rem;
        padding-left: 0;

        &.active {
          padding-left: 0.875rem;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .header {
        &__inner {
          border-bottom: 1px solid $color-secondary;
        }
      }
    }
  }
}

@media (min-width: 1400px) {
  .header {
    :global {
      .order-btn {
        .warn-wrapper {
          &.round {
            border-radius: 21px 0 0 21px;
          }
        }
      }
    }
  }
}

.menuList {
  @include list-unstyled;

  display: flex;
  align-items: center;

  @include max-md {
    display: none;
  }

  :global {
    .menuList {
      &__btn {
        &.isActive {
          color: $color-primary;
          border-color: $color-primary;
        }
      }

      &__icon {
        font-size: 1rem;
        line-height: 0.875rem;

        @include max-md {
          font-size: 1rem;
        }
      }

      &__link {
        @include link-unstyled;

        position: relative;
        display: block;
        padding: 0 2.5em;
        font-size: 0.875rem;
        color: #3f3a2e;
        cursor: pointer;

        @include max-xl {
          padding: 0 1.3rem;
        }

        @include max-lg {
          padding: 0 0.7rem;
        }

        @include max-md {
          display: inline-block;
          padding: 1rem 0;
          font-size: calc(1rem + 0.5vw);
        }

        @include max-2sm {
          padding: 0.5rem 0;
        }

        &:focus,
        &:hover {
          font-weight: 600;

          .menuList {
            &__icon {
              font-weight: 400;
            }
          }
        }

        &.isActive {
          color: $color-primary;
        }
      }

      &__item {
        padding: 1.75rem 0;

        @include max-md {
          // padding: 0 1rem;
        }

        @include max-md {
          width: 100%;
          // padding: 0 1.875rem;
          text-align: center;
        }

        &:not(:last-child) {
          .menuList {
            &__link {
              border-right: 1px solid #d1d1d1;
            }
          }
        }

        &:last-child {
          .menuList {
            &__link {
              padding-right: 0;
            }
          }
        }

        &:first-child {
          .menuList {
            &__link {
              padding-left: 0;
            }
          }
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .menuList {
        &__btn {
          &.isActive {
            position: relative;
            &:before {
              content: '';
              position: relative;
              left: 0;
              width: 5px;
              height: 5px;
              background: $color-primary;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
        &__link {
          color: $color-secondary;
          &.isActive {
            color: $color-primary;
            position: relative;
            &:before {
              content: '';
              position: absolute;
              left: 1rem;
              width: 5px;
              height: 5px;
              background: $color-primary;
              top: 50%;
              transform: translateY(-50%);
              display: block;
              border-radius: 100%;
            }
            @include max-xl {
              &:before {
                left: 0;
              }
            }
          }
        }
        &__item {
          &:not(:last-child) {
            .menuList {
              &__link {
                border: 0;
              }
            }
          }
          &:first-child {
            .menuList {
              &__link {
                &.isActive {
                  &:before {
                    left: -1rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.menuRightList {
  @include list-unstyled;

  display: flex;
  align-items: center;

  @include max-md {
    @include var-height(100, -168px - 60px);

    flex-direction: column;
    align-content: center;
    justify-content: space-between;
    padding: 2.5rem 0;
  }

  @include max-2sm {
    @include var-height(100, -152px - 60px);

    padding: 1rem 0;
  }

  :global {
    .menuRightList {
      &__link {
        @include link-unstyled;

        position: relative;
        // display: block;
        // padding: 0 0.875rem;
        font-size: 0.875rem;
        color: #3f3a2e;
        cursor: pointer;
        border: 1px solid $color-line;
        padding: 0.58rem 0.875rem;
        min-width: 130px;
        display: inline-block;
        text-align: center;
        margin-left: 1rem;
        border-radius: 21px;
        @media screen and (max-width: 1400px) {
          border: 0;
          min-width: auto;
          display: block;
          padding: 0 0.575rem;
        }
        @include max-md {
          display: inline-block;
          padding: 1rem 0;
          font-size: calc(1rem + 0.5vw);
          margin-left: 0;
        }

        @include max-2sm {
          padding: 0.5rem 0;
        }

        &:focus,
        &:hover,
        &.isActive {
          color: $color-primary;
        }

        &.isActive {
          @include unstyled;
          border-color: $color-primary;
        }
      }

      &__btn {
        &.isActive {
          color: $color-primary;
          border-color: $color-primary;
        }
      }

      &__icon {
        font-size: 1.25rem;
        line-height: 0.875rem;
        position: relative;
        top: 2px;

        @include max-md {
          font-size: 1rem;
        }
      }

      &__item {
        padding: 1.17rem 0;
        @media screen and (max-width: 1400px) {
          padding: 1.75rem 0;
        }
        @include max-md {
          // padding: 0 1rem;
        }

        @include max-md {
          width: 100%;
          // padding: 0 1.875rem;
          text-align: center;
        }

        &:last-child {
          .menuRightList {
            &__link {
              // padding-right: 0;
            }
          }
        }

        &:first-child {
          .menuRightList {
            &__link {
              // padding-left: 0;
            }
          }
        }
      }

      &__search {
        display: flex;
        align-items: center;
      }
      &__text {
        // vertical-align: text-top;
        @media screen and (max-width: 1400px) {
          display: none;
        }
      }
      &__reserveCount {
        position: absolute;
        top: -10px;
        right: 0;
        background-color: $color-primary;
        border-radius: 50%;
        height: 20px;
        width: 20px;
        text-align: center;
        color: white;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .menuRightList {
        &__link {
          border-radius: 0;
        }
      }
    }
  }
}

.memberMenuList {
  @include list-unstyled;
  padding: 0.625rem 0;
  :global {
    .memberMenuList {
      &__item {
      }
      &__link {
        @include link-unstyled;
        padding: 0.425rem 1.25rem;
        position: relative;
        display: block;
        font-size: 1rem;
        color: $color-gray-1;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: $color-primary;
        }
      }
    }
  }
}
.bottomMenuList {
  margin-bottom: 1.5rem;
  text-align: center;

  :global {
    ul {
      @include list-unstyled;
    }

    .bottomMenuList {
      &__title {
        margin-bottom: 0.8rem;
        font-size: 0.875rem;
        font-weight: 500;
      }

      &__item {
        @include unstyled;
      }

      &__link {
        @include link-unstyled;

        font-size: 0.75rem;
        line-height: 2;
        color: #3f3a2e;

        &:hover,
        &:focus {
          color: $color-primary;
        }
      }
    }
  }
}

.bottomMenu {
  padding-top: 2rem;

  @include max-2sm {
    padding-top: 1rem;
  }

  :global {
    .bottomMenu {
      @include unstyled;
    }
  }
}

.socialList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0 1rem;
  border-top: $color-gray-3 1px solid;
  // background-color: rgba(#EFE5E0, .3);

  :global {
    .socialList {
      &__item {
        margin: 0 0.5rem;
      }

      &__link {
        @include link-unstyled;

        font-size: 22px;
        color: #3f3a2e;
        cursor: pointer;

        &:hover,
        &:focus {
          color: $color-primary;
        }
      }
    }
  }
}

.headerSearch {
  :global {
    .headerSearch {
      &__box {
        display: inline-block;

        @media (max-width: 860px) {
          height: 60px !important;
          background: white !important;
        }

        .container {
          width: auto;
          padding: 0;

          @include max-xl {
            display: flex;
            width: 100%;
            padding: 0 $container-gap;
          }
        }
      }

      &__inputBox {
        @include max-xl {
          width: 100%;
        }
      }

      &__input {
        padding: 0;
        margin-right: 1rem;
        font-size: 14px;
        letter-spacing: 0.2em;
        border: unset;
        border-radius: 0;
        outline: none;

        @media (max-width: 860px) {
          height: 60px !important;
        }
      }

      &__close {
        display: none;

        @include max-xl {
          display: block;
        }
      }

      @media (max-width: 1200px) {
        /* top: 27.5%;
        right: 9.9rem;
        font-size: 26px; */

        /* @include max-xl {
          top: 22%;
          right: 7.4rem;
          font-size: 22px;
        } */
        &__box {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 80px;
          background: #faf7f6;

          /* @include max-xl {
            height: 62px;
          } */
          .container {
            /* @include max-xl {
              padding: 0 $container-gap;
            } */
          }
        }
        &__inputBox {
          position: relative;
          padding-left: 2.5rem;

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -16px;
            font-family: $font-fontello;
            font-size: 22px;
            content: '\E81D';
          }
        }
        &__input {
          width: 100%;
          height: 85px;
          font-size: 16px;
          background: transparent;
          border: unset;
        }
        &__close {
          position: absolute;
          top: 50%;
          right: 0;
          width: 24px;
          height: 24px;
          margin-top: -12px;

          &::after {
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            content: '';
            background-color: rgba(87, 92, 92);
            transform: rotate(-45deg);
          }

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            content: '';
            background-color: rgba(87, 92, 92);
            transform: rotate(45deg);
          }

          /* @include max-xl {
            display: block;
          } */
        }
      }
    }
  }
}

.mobileMenu {
  position: fixed;
  top: 60px;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc((var(--vh, 1vh) * 100) - 60px);
  pointer-events: none;
  background-color: lighten($color-secondary, 20%);
  box-shadow: inset 0 3px 5px rgba(28, 44, 84, 10%);
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
  transform: translateY(-10px);

  &.isMenuOpen {
    pointer-events: auto;
    opacity: 1;
    transform: translateY(0);
  }

  :global {
    .mobileMenu {
      @include unstyled;
    }
  }
  &.isStyleDingBeauty {
    background-color: lighten($color-secondary, 90%);
  }
}

.mobileMenuList {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;
  // background-color: rgba(#EFE5E0, 0.3);
  overflow-y: auto;

  :global {
    .mobileMenuList {
      &__item {
        align-self: stretch;
        padding: 20px;
        cursor: pointer;
      }

      &__link {
        display: block;
        font-size: 14px;
        color: #3f3a2e;
        text-align: center;

        &.isActive {
          color: $color-primary;
        }

        i {
          font-size: 18px;
        }
      }

      &__hr {
        width: 270px;
        margin: 1vh 0;
        background: $color-line;
        opacity: 0.5;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .mobileMenuList {
        &__link {
          display: block;
          font-size: 14px;
          // color: $color-white;
          text-align: center;

          &.isActive {
            // color: $color-white;
          }

          i {
            font-size: 18px;
          }
        }
      }
    }
  }
}

.mobileMenuListB {
  padding-bottom: 2rem;
  font-family: $font-sans;
  text-align: center;

  :global {
    .mobileMenuListB {
      &__title {
        margin-bottom: 0.5rem;
      }

      &__item {
        @include unstyled;
      }

      &__link {
        display: block;
        font-size: 0.75rem;
        color: #3f3a2e;
        text-align: center;

        &.isActive {
          color: $color-primary;
        }

        i {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
/* #scrollBar {
  padding-top: 80px;

  @include max-lg {
    padding-top: 67px;
  }

  @media (max-width: 860px) {
    padding-top: 60px;
  }
} */
</style>
